<split-steps #steps>
  <split-step>
    <div class="grid">
      <div class="col-5">
        <split-search></split-search>
      </div>
      <div class="col-12 mb-6 pt-0">
        <p-accordion class="m-0 p-0 w-full">
          <ng-container *ngIf="profissao">
            <div class="border-gray" *ngFor="let item of profissao.specialties">
              <p-accordionTab  class="" [ngClass]="item.enable ? '' : 'disabledAccordion'">
                <ng-template pTemplate="header" >
                  <span
                    class="flex align-items-center gap-2 w-full border-top-gray "
                  >
                    <span
                      class="font-bold white-space-nowrap orange-text"
                      [ngClass]="item.enable ? '' : 'text-disable'"
                      >{{ item.name }}</span
                    >
                    <div class="ml-auto mr-4 test2">
                      <div class="col-12 m-0 p-0 my-2 text-right">
                        <p-button
                          *ngIf="item.enable"
                          class="ml-4"
                          [rounded]="true"
                          [text]="true"
                          severity="orange-primary"
                          (onClick)="
                            $event.stopPropagation(); disableCard(item)
                          "
                        >
                          <ng-template pTemplate="icon">
                            <div class="flex">
                              <split-icon size="small" name="ban"></split-icon>
                            </div>
                          </ng-template>
                        </p-button>
                        <p-button
                          *ngIf="!item.enable"
                          class="ml-4"
                          [rounded]="true"
                          [text]="true"
                          severity="success"
                          (onClick)="
                            $event.stopPropagation(); disableCard(item)
                          "
                        >
                          <ng-template pTemplate="icon">
                            <div class="flex">
                              <split-icon
                                size="small"
                                name="disban"
                              ></split-icon>
                            </div>
                          </ng-template>
                        </p-button>
                      </div>
                    </div>
                  </span>
                </ng-template>
                <span
                  *ngFor="let service of item.service"
                  class="flex align-items-center gap-2 w-full border-top-gray mb-5"
                >
                  <span class="ml-5 gray-text"> {{ service.name }}</span>
                  <div
                    class="ml-auto mr-4 text-underline"
                    [ngClass]="service.enable ? 'green-enable' : 'red-disable'"
                    (click)="$event.stopPropagation(); disableService(service)"
                  >
                    {{ service.enable ? "Ativo" : "Inativo" }}
                  </div>
                </span>
              </p-accordionTab>
            </div>
          </ng-container>
        </p-accordion>
      </div>
    </div>
  </split-step>

  <ng-template #customPreviousButton *ngIf="steps.activeIndex == 0">
    <div class="col-12 py-0 px-0">
      <p-button
        (onClick)="closeForm()"
        severity="secondary"
        [outlined]="true"
        label="Cancelar"
      ></p-button>
    </div>
  </ng-template>
  <ng-template #customNextButton *ngIf="steps.activeIndex == 0">
    <div class="col-12 p-0 text-right">
      <p-button (onClick)="saveForm()" class="ml-4" label="Salvar"></p-button>
    </div>
  </ng-template>
</split-steps>
